import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// Abstract polymorphic resource for the `observable` role (Account or Loan,
// resolved from the payload). `observation.observable` is a polymorphic
// belongsTo with `inverse: null`, so this marker resource needs no fields — it
// exists only so `schema.fields({ type: 'observable' })` resolves through the
// schema service instead of recursing into the legacy ModelSchemaProvider /
// ShimModelClass (RangeError: Maximum call stack size exceeded).
const ObservableSchema = withDefaults({
  type: 'observable',
  fields: [],
});

export default ObservableSchema;
